import {
  UserSubscriptionRequestStatusEnum
} from '../../app/modules/user-subscription-request/enums/user-subscription-request-status.enum';

export const DEFAULT_USER_SUBSCRIPTION_REQUEST_STATUS = [
  UserSubscriptionRequestStatusEnum.TO_REVIEW,
  UserSubscriptionRequestStatusEnum.REJECT,
  UserSubscriptionRequestStatusEnum.PENDING,
  UserSubscriptionRequestStatusEnum.ACTIVE,
  UserSubscriptionRequestStatusEnum.TO_PAY];
